import React from "react";
import InputMask from "react-input-mask";
import { StyledInput } from "./styles";

const CNPJ_FORMAT_CHARS = {
  A: '[0-9A-Za-z]',
  9: '[0-9]',
};

export const InputCNPJ = ({ error, cnpj, handleChange, disabled }) => {
 const handleCNPJChange = (event) => {
   handleChange({
     ...event,
     target: {
       ...event.target,
       name: event.target.name,
       value: event.target.value.toUpperCase(),
     },
   });
 };

 return( 
    <StyledInput>
      <div className="group">      
        <InputMask
          mask="AA.AAA.AAA/AAAA-99"
          formatChars={CNPJ_FORMAT_CHARS}
          maskChar="_"
          required
          id="cnpj"
          name="cnpj"                         
          value={cnpj}
          className={error}
          onChange={handleCNPJChange}
          disabled={disabled ? 'disabled' : ''}
        />
        <span className="highlight"></span>
        <span className="bar"></span>
        {
          disabled 
            ? ''
            : <label id="label_cnpj">CNPJ *</label>
        }
      </div>
    </StyledInput> 
  )
};
